/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetUsersAPIKeysOptions, GetUsersAPIKeysResponses } from '../types/GetUsersAPIKeys'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get user's api keys
 * {@link /v1/user/apikey}
 */
export function getUsersAPIKeys<ThrowOnError extends boolean = true>(
  options: Options<GetUsersAPIKeysOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetUsersAPIKeysResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/user/apikey',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetUsersAPIKeysResponses, ThrowOnError>>,
  )
}
